import { render, staticRenderFns } from "./ManagePracticeUser.vue?vue&type=template&id=5d496007&scoped=true"
import script from "./ManagePracticeUser.vue?vue&type=script&lang=js"
export * from "./ManagePracticeUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d496007",
  null
  
)

export default component.exports